// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"2d75df2b","703":"9df55091"}[chunkId] + ".chunk.js";
};